import { useEffect, useRef, useState } from "react";
import { countAtSigns } from "@/lib/utils/mentionUtils";

type ResetKey = string | number | boolean | null | undefined;

/**
 * `@` が新たに入力されたら true を返し、resetKey 変更で状態をリセットする。
 */
export const useMentionInputNotice = (
  value: string,
  initialValue: string,
  resetKey: ResetKey,
): boolean => {
  const [hasTypedMention, setHasTypedMention] = useState(false);
  const previousAtCountRef = useRef(countAtSigns(initialValue));
  const previousResetKeyRef = useRef<ResetKey>(resetKey);

  useEffect(() => {
    if (previousResetKeyRef.current !== resetKey) {
      setHasTypedMention(false);
      previousAtCountRef.current = countAtSigns(initialValue);
      previousResetKeyRef.current = resetKey;
      return;
    }

    const currentAtCount = countAtSigns(value);
    if (currentAtCount > previousAtCountRef.current) {
      setHasTypedMention(true);
    }
    previousAtCountRef.current = currentAtCount;
  }, [initialValue, resetKey, value]);

  return hasTypedMention;
};
